import Card from 'components/Shared/Card';
import QRCode from 'qrcode.react';
import React from 'react';

// Telegram Paper Plane Icon
const TelegramIcon = ({size = 40}) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" fill="url(#telegram-gradient)" />
    <path d="M10.5 23.5L33.5 13.5L28.5 34.5L22.5 27.5L33.5 17.5L18.5 25.5L10.5 23.5Z" fill="white" />
    <path d="M22.5 27.5V33.5L25.5 29.5" fill="white" />
    <defs>
      <linearGradient id="telegram-gradient" x1="24" y1="0" x2="24" y2="48" gradientUnits="userSpaceOnUse">
        <stop stopColor="#37AEE2" />
        <stop offset="1" stopColor="#1E96C8" />
      </linearGradient>
    </defs>
  </svg>
);

const TelegramCard = ({title, telegramUrl}) => (
  <Card className="flex flex-col items-center py-6">
    <div
      className="text-2xl font-bold mb-4"
      style={{
        background: 'linear-gradient(135deg, #37AEE2 0%, #1E96C8 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
      }}>
      {title}
    </div>

    <div
      className="p-3 rounded-xl mb-4"
      style={{
        background: 'linear-gradient(135deg, #37AEE2 0%, #1E96C8 100%)',
        padding: '8px',
      }}>
      <div className="bg-white p-2 rounded-lg">
        <QRCode level="M" size={120} value={telegramUrl} fgColor="#1E96C8" />
      </div>
    </div>

    <a
      href={telegramUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center px-5 gap-2 py-1  rounded-full font-bold text-lg transition-all hover:scale-105"
      style={{
        background: '#ffffff',
        border: '3px solid #37AEE2',
        color: '#1E96C8',
        boxShadow: '0 4px 15px rgba(55, 174, 226, 0.3)',
      }}>
      <TelegramIcon size={24} />
      <span>Telegram</span>
    </a>

    <p className="mt-3 text-gray-300 text-sm">แตะเพื่อเปิด Telegram</p>
  </Card>
);

const TelegramContact = props => {
  const {telegram1Url, telegram2Url} = props;

  return (
    <div className="grid grid-cols-1 gap-4">
      {telegram1Url && <TelegramCard title="" telegramUrl={telegram1Url} />}
      {telegram2Url && <TelegramCard title="" telegramUrl={telegram2Url} />}
    </div>
  );
};

export default TelegramContact;
